import React from 'react';
import { useDispatch } from 'react-redux';
import { useUnsubscribeOverflow } from 'hooks';
import CameraStream from 'components/widgets/CameraInput/CameraStream/Default';
import { hideModal } from 'redux/actions/global';

interface IProps {
  isSelfie: boolean;
  onCapture: (img: string) => void;
}

const CameraModal = ({ isSelfie, onCapture }: IProps) => {
  const dispatch = useDispatch();

  useUnsubscribeOverflow();

  const capture = (img: string) => {
    onCapture(img);
    dispatch(hideModal());
  };

  return <CameraStream isSelfie={isSelfie} onCapture={capture} />;
};

export default CameraModal;
